var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRewardsBackgroundLarge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1298,
    height: 237,
    viewBox: "0 0 1298 237",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_8_620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M716.999 -16.229C614.761 -25.961 454.305 -53.2647 386.856 -65.7C347.807 -72.4584 242.871 -86.9482 135.522 -90.841C1.3347 -95.707 -169.062 12.156 -64.6939 94.067C39.6739 175.978 619.021 146.782 676.53 136.239C734.039 125.696 716.999 81.091 834.147 67.304C951.294 53.517 1136.6 88.39 1272.92 67.304C1409.23 46.218 844.796 -4.06405 716.999 -16.229Z",
    fill: "url(#paint0_linear_8_620)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_8_620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M573.562 -1.42878C504.503 -8.011 396.119 -26.4778 350.56 -34.8884C324.183 -39.4594 253.302 -49.2596 180.79 -51.8925C90.1506 -55.1836 -24.9473 17.7694 45.5502 73.1698C116.048 128.57 507.38 108.823 546.226 101.693C585.072 94.562 573.562 64.3935 652.691 55.0686C731.821 45.7438 856.99 69.3301 949.069 55.0686C1041.15 40.8072 659.885 6.79901 573.562 -1.42878Z",
    fill: "url(#paint1_linear_8_620)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter2_f_8_620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M573.562 -1.42878C504.503 -8.011 396.119 -26.4778 350.56 -34.8884C324.183 -39.4594 253.302 -49.2596 180.79 -51.8925C90.1506 -55.1836 -24.9473 17.7694 45.5502 73.1698C116.048 128.57 507.38 108.823 546.226 101.693C585.072 94.562 573.562 64.3935 652.691 55.0686C731.821 45.7438 856.99 69.3301 949.069 55.0686C1041.15 40.8072 659.885 6.79901 573.562 -1.42878Z",
    fill: "url(#paint2_linear_8_620)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_8_620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M930.503 124.5C936.802 115.3 1010.99 103.333 1047.29 98.5C1059.1 132.833 1075.64 204.5 1047.29 216.5C1011.86 231.5 838.644 204.5 824.21 195C809.775 185.5 818.961 170 884.574 164C950.187 158 922.629 136 930.503 124.5Z",
    fill: "#00575F"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_8_620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M791.403 21.9997C686.422 9.5997 549.947 -11.8336 494.832 -21.0003C434.905 -26.167 335.523 -32.0003 417.408 -14.0003C499.293 3.9997 700.857 17.4997 791.403 21.9997Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_8_620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.799 109C330.799 109 164.579 97.8333 128.71 92.5C107.714 94 78.3191 98.6 128.71 105C179.101 111.4 284.432 110.333 330.799 109Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8_620",
    x: -101,
    y: -95,
    width: 1399,
    height: 249,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_8_620"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_8_620",
    x: 15.7283,
    y: -60,
    width: 955.581,
    height: 179,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_8_620"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_8_620",
    x: 15.7283,
    y: -60,
    width: 955.581,
    height: 179,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_8_620"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_8_620",
    x: 802.317,
    y: 82.5,
    width: 276.628,
    height: 154.444,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_8_620"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_8_620",
    x: 374.38,
    y: -38.1934,
    width: 429.024,
    height: 72.1931,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_8_620"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_8_620",
    x: 88.8866,
    y: 80.5,
    width: 253.912,
    height: 41.5115,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_8_620"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8_620",
    x1: 14.1154,
    y1: -46.2366,
    x2: 1165.77,
    y2: 642.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11B3C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00575F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8_620",
    x1: 98.7836,
    y1: -21.7243,
    x2: 877.226,
    y2: 443.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11B3C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00575F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8_620",
    x1: 98.7836,
    y1: -21.7243,
    x2: 877.226,
    y2: 443.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.135417,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00575F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardsBackgroundLarge);
export default __webpack_public_path__ + "static/media/rewards-background-large.7905f773c0221d15e1155ae7ff57872f.svg";
export { ForwardRef as ReactComponent };